import React from 'react';
import {NeuroMessage} from '@ignitesales/neuro-application';
import {MessagePropTypes} from "../utils/propTypes.mjs";

const GuideName = ({ tagName = '', className }) => {
    return ( <NeuroMessage id='guide.name' tagName={tagName} className={className} /> );
};
GuideName.propTypes = MessagePropTypes;

export {
    GuideName,
    GuideName as GuideNameMessage
};
